import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

/* Renders markdown to HTML */
@Pipe({
	name: 'markdown',
	pure: false
})
export class MarkDownPipe implements PipeTransform {
	private static renderer: { render(source: string): string } | null = null;
	private static loader: Promise<void> | null = null;

	private lastValue: string | null | undefined;
	private lastResult = '';
	private markScheduled = false;

	constructor(private readonly cdr: ChangeDetectorRef) {}

	transform(value: string | null | undefined): string {
		if (!value) {
			this.lastValue = value;
			this.lastResult = '';
			return '';
		}

		if (MarkDownPipe.renderer) {
			if (value !== this.lastValue) {
				this.lastValue = value;
				this.lastResult = MarkDownPipe.renderer.render(value);
			}
			return this.lastResult;
		}

		this.scheduleLoad();
		return '';
	}

	private scheduleLoad(): void {
		if (!MarkDownPipe.loader) {
			MarkDownPipe.loader = import('markdown-it').then(mod => {
				const create = ((mod as any).default ?? mod) as () => { render(source: string): string };
				MarkDownPipe.renderer = create();
			});
		}

		if (!this.markScheduled) {
			this.markScheduled = true;
			MarkDownPipe.loader.then(() => this.cdr.markForCheck());
		}
	}
}
